import { defineComponent as _defineComponent } from 'vue'
import ProductRegistrationService from '@/services/product-registration.service';
import { useValidator } from '@/core/app.service';
import PageService from '@/core/page.service';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterProductBySerialNumberPage',
  props: {
    searchPageUrl: null,
    registerProductDetailsUrl: null
  },
  setup(__props: any) {

const props = __props as {
    searchPageUrl: string,
    registerProductDetailsUrl: string
}



const serialNumber = ref<string>('');
const $validator = useValidator();

function submit() {
    $validator.validateAll().then(isValid => {
        ProductRegistrationService.getProductStatus(serialNumber.value).then(() => {
            // TODO: Indicate whether product is stolen or registered?
            PageService.softRedirect(props.registerProductDetailsUrl);
        });
    });
}

return { __sfc: true,props, serialNumber, $validator, submit }
}

})